import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SectionHero from '../../components/sections/SectionHero';
import SectionTrustBar from '../../components/sections/SectionTrustBar';
import SectionServices from '../../components/sections/SectionServices';
import SectionMidCTA from '../../components/sections/SectionMidCTA';
import SectionAIBlock from '../../components/sections/SectionAIBlock';
import SectionProcess from '../../components/sections/SectionProcess';
import SectionWhyUs from '../../components/sections/SectionWhyUs';
import SectionAreas from '../../components/sections/SectionAreas';
import SectionTestimonials from '../../components/sections/SectionTestimonials';
import SectionFAQ from '../../components/sections/SectionFAQ';
import SectionFinalCTA from '../../components/sections/SectionFinalCTA';

const heroImage =
  'https://public.readdy.ai/ai/img_res/d55029a0112c48e9bef71142cba5d417.jpg';

const services = [
  {
    icon: 'ri-book-open-line',
    title: 'Scuba Certification Programs',
    description:
      'Structured training from beginner to advanced levels — PADI, SSI, SDI, and beyond. Every diver leaves certified, confident, and genuinely prepared for real ocean diving.',
    image:
      'https://readdy.ai/api/search-image?query=professional%20scuba%20certification%20training%20instructor%20teaching%20student%20underwater%20pool%20clear%20bright%20water%20PADI%20SSI%20mask%20fins%20wetsuit%20structured%20learning%20professional%20dive%20school%20Miami&width=700&height=500&seq=home-svc-1-v3&orientation=landscape',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Guided Dive Experiences',
    description:
      'Expert-led dives in Biscayne Bay and beyond — designed for safety, discovery, and unforgettable encounters with Miami\'s spectacular marine environments.',
    image:
      'https://readdy.ai/api/search-image?query=dive%20guide%20leading%20scuba%20divers%20underwater%20coral%20reef%20tropical%20fish%20Miami%20Biscayne%20Bay%20crystal%20clear%20warm%20water%20professional%20guided%20diving%20experience%20cinematic&width=600&height=400&seq=home-svc-2-v3&orientation=landscape',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Technical & Specialty Diving',
    description:
      'Deep diving, rescue, technical programs, and 15+ specialty certifications. Push your limits with expert TDI and ERDI-certified mentorship.',
    image:
      'https://readdy.ai/api/search-image?query=technical%20scuba%20diver%20advanced%20deep%20water%20dramatic%20lighting%20professional%20diver%20silhouette%20specialty%20certification%20night%20wreck%20diving%20professional%20equipment%20sidemount%20rebreather&width=600&height=400&seq=home-svc-3-v3&orientation=landscape',
  },
  {
    icon: 'ri-anchor-line',
    title: 'Biscayne National Park Trips',
    description:
      'Exclusive dive boat excursions into Biscayne National Park — one of Florida\'s most spectacular and biodiverse marine environments.',
    image:
      'https://readdy.ai/api/search-image?query=Biscayne%20National%20Park%20underwater%20coral%20reef%20tropical%20fish%20diving%20boat%20trip%20clear%20warm%20water%20Florida%20Keys%20marine%20reserve%20stunning%20underwater%20photography%20colorful%20reef&width=600&height=400&seq=home-svc-4-v3&orientation=landscape',
  },
  {
    icon: 'ri-ship-line',
    title: 'Private Charters & Snorkeling',
    description:
      'Private boat charters, group snorkeling experiences, and custom dive trips tailored for families, couples, and corporate groups.',
    image:
      'https://readdy.ai/api/search-image?query=private%20boat%20charter%20snorkeling%20Miami%20Biscayne%20Bay%20clear%20turquoise%20tropical%20water%20small%20group%20luxury%20private%20tour%20ocean%20Florida%20Keys%20beautiful&width=600&height=400&seq=home-svc-5-v3&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'Equipment Rental',
    description:
      'Full scuba equipment rental — BCD, regulator, wetsuit, mask, fins, and dive computer. All professionally maintained and perfectly fitted.',
    image:
      'https://readdy.ai/api/search-image?query=professional%20scuba%20diving%20equipment%20rental%20gear%20organized%20display%20BCD%20regulator%20wetsuit%20fins%20mask%20tank%20professional%20dive%20center%20clean%20organized%20professional%20quality&width=600&height=400&seq=home-svc-6-v3&orientation=landscape',
  },
];

const steps = [
  {
    number: '01',
    title: 'Free Consultation',
    description: 'We assess your goals, experience level, and schedule — then recommend the program that fits you best.',
    icon: 'ri-chat-3-line',
    detail: 'No commitment. Just a genuine conversation about what you want from diving.',
  },
  {
    number: '02',
    title: 'Training & Theory',
    description: 'Classroom or eLearning theory combined with structured pool sessions to master every core skill.',
    icon: 'ri-book-2-line',
    detail: 'Flexible scheduling — evenings, weekends, and accelerated formats available.',
  },
  {
    number: '03',
    title: 'Ocean Certification Dives',
    description: 'Real open water dives from our Pier 5 dive boat in Biscayne Bay with full professional supervision.',
    icon: 'ri-anchor-line',
    detail: 'Every dive is conducted in Miami\'s warm, clear coastal waters — not a quarry.',
  },
  {
    number: '04',
    title: 'Certified & Ready',
    description: 'Receive your internationally recognized certification and continue to advanced programs at your pace.',
    icon: 'ri-award-line',
    detail: 'Your certification card is recognized in every major diving destination worldwide.',
  },
];

const reasons = [
  {
    icon: 'ri-focus-3-line',
    title: 'Precision-Based Instruction',
    description: 'Not rushed certification. Every skill is taught, practiced, and confirmed before moving forward.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safety Above Everything',
    description: 'We train you for actual ocean conditions — not just pool environments. Safety is never compromised.',
  },
  {
    icon: 'ri-anchor-line',
    title: 'Waterfront Dive Boat Operation',
    description: 'Our Pier 5 home on Biscayne Bay means you\'re diving from a real boat, in real conditions, from day one.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Individual-Level Attention',
    description: 'Small class sizes and dedicated instructors ensure every diver progresses at the right pace.',
  },
  {
    icon: 'ri-award-line',
    title: 'Five-Agency Accreditation',
    description: 'PADI, SSI, SDI, TDI, and ERDI certified — credentials recognized everywhere in the world.',
  },
];

const areas = [
  'Miami', 'Miami Beach', 'Coral Gables', 'Brickell', 'Coconut Grove',
  'Key Largo', 'Key West', 'Fort Lauderdale', 'Biscayne Bay',
  'Biscayne National Park', 'South Beach', 'Aventura',
];

const testimonials = [
  {
    name: 'Marcus R.',
    role: 'Open Water Diver — Miami',
    rating: 5,
    quote:
      'I came in nervous, had never dived before, and left fully certified in 4 days. The level of instruction at Ace Diving is genuinely exceptional — they don\'t just certify you, they actually prepare you. The whole team made it feel completely safe from start to finish.',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20confident%20smiling%20man%20portrait%20headshot%20dark%20hair%20natural%20background%20casual%20outdoor%20photography%20warm%20light&width=100&height=100&seq=avatar-home-1-v3&orientation=squarish',
  },
  {
    name: 'Jessica L.',
    role: 'Advanced Open Water — Brickell',
    rating: 5,
    quote:
      'Not just a certification — real training. The instructors are passionate, the ocean dives were incredible, and the safety focus made me feel completely confident in open water. Already booked my rescue diver course.',
    avatar:
      'https://readdy.ai/api/search-image?query=confident%20professional%20smiling%20woman%20portrait%20headshot%20natural%20light%20clean%20background%20outdoor%20photography&width=100&height=100&seq=avatar-home-2-v3&orientation=squarish',
  },
  {
    name: 'Daniel T.',
    role: 'Rescue Diver — Coral Gables',
    rating: 5,
    quote:
      'Best dive instruction I\'ve encountered in South Florida — full stop. The rescue course was intense, comprehensive, and genuinely life-changing. These instructors hold you to a real standard.',
    avatar:
      'https://readdy.ai/api/search-image?query=confident%20professional%20man%20headshot%20business%20casual%20warm%20natural%20lighting%20clean%20background%20portrait%20outdoor&width=100&height=100&seq=avatar-home-3-v3&orientation=squarish',
  },
];

const faqs = [
  {
    question: 'Who offers professional scuba diving training in Miami?',
    answer:
      'Ace Diving Miami is a PADI, SSI, SDI, TDI, and ERDI-certified dive center at Pier 5, Biscayne Blvd, Miami. They serve all skill levels from complete beginners through technical divers, with a philosophy built on genuine safety and real ocean readiness — not just fast certification.',
  },
  {
    question: 'How much does scuba certification cost in Miami?',
    answer:
      'Scuba certification pricing at Ace Diving Miami varies by program level and inclusions — pool sessions, open water dives, and equipment. They offer transparent, competitive pricing with no hidden fees. Contact the team at +1 786-241-3194 for accurate pricing based on your goals.',
  },
  {
    question: 'How long does it take to get scuba certified in Miami?',
    answer:
      'Most Open Water certification programs at Ace Diving Miami can be completed in 3–5 days, depending on your schedule. The process includes eLearning theory, confined water pool skills practice, and 4 real open water certification dives in Miami\'s warm coastal environment.',
  },
  {
    question: 'Where can I book snorkeling or private dive trips in Miami?',
    answer:
      'Ace Diving Miami runs guided dive boat trips from Pier 5 on Biscayne Blvd — including snorkeling tours, private charters, and Biscayne National Park excursions. Call +1 786-241-3194 or fill out the contact form to check availability and book your Miami dive experience.',
  },
  {
    question: 'Does Ace Diving offer technical diving training in Miami?',
    answer:
      'Yes. As a TDI and ERDI certified center, Ace Diving Miami provides full technical diving instruction including advanced nitrox, decompression diving, and public safety diving programs — making them one of the most comprehensive dive training facilities in South Florida.',
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <SectionHero
          eyebrow="Professional Scuba Training · Miami, FL"
          headline={
            <>
              Where Elite<br />
              Divers Are<br />
              <span className="text-[#00B4D8]">Made.</span>
            </>
          }
          subheadline="Professional scuba training, guided diving, and certification programs from Miami's premier waterfront dive center — built for those who expect mastery, not just a card."
          cta1={{ text: 'Start Your Diving Journey', href: '#contact' }}
          cta2={{ text: 'Speak With a Specialist', href: 'tel:+17862413194' }}
          stats={[
            { value: '15+', label: 'Years in Miami' },
            { value: '2,400+', label: 'Certified Divers' },
            { value: '5', label: 'Cert Agencies' },
            { value: '100%', label: 'Safety Record' },
          ]}
          backgroundImage={heroImage}
          backgroundAlt="Professional scuba diver underwater Miami — Ace Diving"
        />
        <SectionTrustBar />
        <SectionServices
          headline="Professional Diving Services for Every Level"
          services={services}
          ctaText="View All Programs"
          ctaHref="#contact"
        />
        <SectionMidCTA
          headline="Questions? Let's Talk First."
          subheadline="Speak with a dive specialist before you commit to anything. We'll find the right program for your goals, experience, and schedule."
          cta1={{ text: 'Start Your Journey', href: '#contact' }}
          cta2={{ text: '+1 786-241-3194', href: 'tel:+17862413194' }}
        />
        <SectionAIBlock
          headline="What Is Ace Diving Miami?"
          lead="Ace Diving Miami is South Florida's premier PADI, SSI, SDI, TDI, and ERDI certified dive center — providing professional scuba training, guided dives, private charters, and technical diving programs from their waterfront base at Pier 5, 401 Biscayne Blvd."
          paragraphs={[
            'Their services cover the full spectrum: beginner scuba certification through advanced open water, rescue diver, divemaster, and technical diving programs — plus guided reef dives, snorkeling tours, private boat charters, and Biscayne National Park excursions.',
            'Founded on a single principle — produce divers who are genuinely ready, not just certified — Ace Diving Miami brings over 15 years of Miami diving expertise, multi-agency accreditation, and a real waterfront boat operation to every program they run.',
          ]}
          tags={[
            'Open Water Certification',
            'Advanced Diver',
            'Rescue Diving',
            'Technical Diving',
            'Divemaster',
            'Private Charters',
            'Biscayne National Park',
            'Snorkeling Trips',
          ]}
        />
        <SectionProcess
          headline="A Structured Path to Confident, Capable Diving"
          steps={steps}
          ctaText="Start the Conversation"
        />
        <SectionWhyUs
          headline="Why Divers in Miami Choose Ace Diving"
          reasons={reasons}
          image="https://readdy.ai/api/search-image?query=professional%20scuba%20diving%20instructor%20experienced%20expert%20on%20dive%20boat%20Miami%20Biscayne%20Bay%20waterfront%20teaching%20safety%20equipment%20check%20professional%20instructor%20cinematic%20portrait%20ocean%20sunset&width=700&height=900&seq=why-home-v3&orientation=portrait"
          imageAlt="Ace Diving Miami — professional instructor on dive boat"
          ctaText="Train With Our Team"
          badge1={{ label: 'PADI / SSI / SDI / TDI / ERDI', sublabel: 'Multi-Agency Certified' }}
          badge2={{ value: '15+', label: 'Years in Miami' }}
          extraParagraph="At Ace Diving Miami, the standard has always been clear: if you train here, you leave genuinely ready. That commitment defines every program, every instructor, and every dive we\'ve led for over 15 years."
        />
        <SectionAreas
          headline="Serving Divers Across South Florida"
          description="From our waterfront base at Pier 5 on Biscayne Blvd, we provide scuba training and guided dive services across Miami and the greater South Florida region. All dive environments are selected for optimal safety, visibility, and marine life."
          areas={areas}
          ctaText="Check Availability"
        />
        <SectionTestimonials
          headline="What Divers Say About Their Experience"
          testimonials={testimonials}
          ctaText="Start Your Journey"
        />
        <SectionFAQ
          headline="Common Questions About Scuba Diving in Miami"
          faqs={faqs}
        />
        <SectionFinalCTA
          headline="Start Your Diving Experience With Confidence"
          subheadline="Take the first step toward professional scuba training and real underwater capability. Our team is ready to build a program around your exact goals."
          ctaText="Get Started Today"
        />
      </main>
      <Footer />
    </div>
  );
}
